var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzurePrdct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6606 46.1844C29.0564 45.3932 28.0829 44.9755 27.0936 45.0831C26.1044 45.1907 25.2432 45.8078 24.8229 46.7104L0.309268 95.7569C-0.144783 96.6658 -0.0962469 97.7451 0.437545 98.6094C0.971337 99.4738 1.91428 99.9999 2.92965 100H37.0636C38.1806 100.026 39.2078 99.3906 39.684 98.3792C47.0471 83.1533 42.5848 60.0025 29.6606 46.1844Z",
    fill: "url(#paint0_linear_2956_115)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6402 1.57342C35.2139 20.707 33.7797 44.9766 43.8659 65.4425L60.3222 98.3784C60.8185 99.3717 61.8329 99.9991 62.9426 99.9992H97.0704C98.0858 99.9991 99.0288 99.473 99.5626 98.6086C100.096 97.7443 100.145 96.665 99.6908 95.7561C99.6908 95.7561 53.7774 3.85369 52.6235 1.55502C52.158 0.600239 51.1877 -0.00390119 50.1261 1.89634e-05C49.0645 0.00393912 48.0987 0.615229 47.6402 1.57342Z",
    fill: "#2684FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2956_115",
    x1: 43.0951,
    y1: 53.7536,
    x2: 8.71164,
    y2: 90.6628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#2684FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzurePrdct);
export default __webpack_public_path__ + "static/media/azure-prdct.b74359042a87a49097d644b2f68196ce.svg";
export { ForwardRef as ReactComponent };